export const defaultQueryOptions = {
  keepPreviousData: true,
  refetchIntervalInBackground: false,
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  retry: (failureCount: number, error: any) => {
    // Disable retry for 403 (Access Denied) errors
    if (error?.response?.status === 403) {
      return false;
    }
    // Default retry behavior: retry up to 3 times for other errors
    return failureCount < 3;
  },
};
